class LdropDeliveryEtaCard extends HTMLElement {
  constructor() {
    super();
    this.updateUI = this.updateUI.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.updateUI();
    this.intervalId = window.setInterval(this.updateUI, 60000);
    document.addEventListener('ldrop:variant-change', this.handleVariantChange);
  }

  disconnectedCallback() {
    if (this.intervalId != null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
    document.removeEventListener('ldrop:variant-change', this.handleVariantChange);
  }

  handleVariantChange(event) {
    const detail = event.detail ?? {};
    if (detail.variantId != null) {
      this.dataset.variantId = String(detail.variantId);
    }
    if (detail.inventory != null) {
      this.dataset.inventory = typeof detail.inventory === 'string'
        ? detail.inventory
        : JSON.stringify(detail.inventory);
    }
    this.updateUI();
  }

  updateUI() {
    const cutoffHour = Number.parseInt(this.dataset.cutoffHour ?? '14', 10);
    const tzOffsetHours = Number.parseInt(this.dataset.timezoneOffset ?? '4', 10);
    const variantId = this.dataset.variantId;
    const threshold = Number.parseInt(this.dataset.lowStockThreshold ?? '5', 10);

    const now = new Date();
    const utcMs = now.getTime() + (now.getTimezoneOffset() * 60000);
    const targetTime = new Date(utcMs + (tzOffsetHours * 3600000));
    const cutoff = new Date(targetTime);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    const options = { month: 'short', day: 'numeric' };
    const windowEl = this.querySelector('[data-role="eta-window"]');
    const timerEl = this.querySelector('[data-role="eta-timer"]');

    if (targetTime < cutoff) {
      const diffMs = cutoff - targetTime;
      const hours = Math.floor(diffMs / 3600000);
      const minutes = Math.floor((diffMs % 3600000) / 60000);
      const dayAfter = new Date(targetTime);
      dayAfter.setDate(targetTime.getDate() + 2);

      if (windowEl) {
        windowEl.textContent = `tomorrow or ${dayAfter.toLocaleDateString('en-US', options)}`;
      }
      if (timerEl) {
        timerEl.textContent = `Order within ${hours}h ${minutes}m for today's dispatch`;
      }
    } else {
      const dayAfterTomorrow = new Date(targetTime);
      dayAfterTomorrow.setDate(targetTime.getDate() + 2);
      const thirdDay = new Date(targetTime);
      thirdDay.setDate(targetTime.getDate() + 3);

      if (windowEl) {
        windowEl.textContent = `${dayAfterTomorrow.toLocaleDateString('en-US', options)} or ${thirdDay.toLocaleDateString('en-US', options)}`;
      }
      if (timerEl) {
        timerEl.textContent = 'Order now for priority dispatch tomorrow morning';
      }
    }

    this.updateLowStock(variantId, threshold);
  }

  updateLowStock(variantId, threshold) {
    const alertEl = this.querySelector('[data-role="low-stock"]');
    const countEl = this.querySelector('[data-role="low-stock-count"]');
    if (alertEl == null || countEl == null) return;

    const inventory = this.readInventory();
    const stock = inventory[variantId];

    if (stock != null && stock > 0 && stock <= threshold) {
      countEl.textContent = String(stock);
      alertEl.hidden = false;
    } else {
      alertEl.hidden = true;
    }
  }

  readInventory() {
    try {
      return JSON.parse(this.dataset.inventory ?? '{}');
    } catch {
      return {};
    }
  }
}

if (!customElements.get('ldrop-delivery-eta-card')) {
  customElements.define('ldrop-delivery-eta-card', LdropDeliveryEtaCard);
}
